import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EnfoqueService } from 'src/app/services/enfoque.service';
import { EventMantenedorEnfoqueService } from 'src/app/services/event-mantenedor-enfoque.service';
@Component({
  selector: 'app-table-enfoque',
  templateUrl: './table-enfoque.component.html',
  styleUrls: ['./table-enfoque.component.scss']
})
export class TableEnfoqueComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElementEnfoque: DataTableDirective;
  dtTriggerEnfoque: Subject<any> = new Subject();
  loadingEnfoque = false;
  searchT: string = "";
  pageActualEnfoque = 1
  enfoqueMantenedor: any;
  enfoqueFilter: any;
  enfoque: any;
  enfoqueSelected: any;
  enfoqueIdSelected: number;
  creationMode: string;
  confirmationModalTittle: string;
  confirmationModalMessage: string;
  confirmationModalHasComment = false;
  confirmationModalHasOptions = false;
  confirmationModalisCommentObligatory = false;
  confirmationModalAccept: any;
  confirmationModalOptionLabel: string;
  confirmationModalOptions: { label: string, value: any }[];
  inputMessageModal: string = "";
  initialArrayEnfoque: any = [];
  constructor(private enfoqueService: EnfoqueService,
    private modalService: NgbModal,
    private eventMantenedorEnfoqueService: EventMantenedorEnfoqueService) { }

  ngOnInit() {
    this.refreshEnfoque();

    if (this.eventMantenedorEnfoqueService.subsVar == undefined) {
      this.eventMantenedorEnfoqueService.subsVar = this.eventMantenedorEnfoqueService.
        invokeFirstComponentFunction.subscribe(() => {
          this.refreshEnfoque();
        });
    }
  }

  ngAfterViewInit(): void {
    this.dtTriggerEnfoque.next();
  }

  ngOnDestroy(): void {
    this.dtTriggerEnfoque.unsubscribe();
  }

  refreshEnfoque() {
    Promise.all([
      this.getZonasMantenedor()
    ])
      .then(results => {
        this.enfoqueMantenedor = results[0];
        this.enfoqueFilter = results[0];
        this.initialArrayEnfoque = results[0]
        this.rerenderEnfoque();
      })
      .catch(error => {
        this.loadingEnfoque = false;
        console.error(error);
      });
  }

  refreshEnfoqueCreateOrUpdate(event):void{
    console.log(event)
    this.inputMessageModal = event;
    this.refreshEnfoque()
  }

  changeSearch(e) {
     let valor = e.target.value
    console.log('Filtrando valores')
    console.log(e.target.value)
    console.log(valor.length)

    if (valor.length > 0) {
      this.pageActualEnfoque = 1;
      let word = valor.toLowerCase();
      this.enfoqueMantenedor = this.initialArrayEnfoque.filter((item) => {
        let str = item.enfoqueId + item.enfoqueDescription
        str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return str.toLowerCase().search(word) > -1
      }
      )
      console.log('Registros encontrados')
      console.log(this.enfoqueMantenedor.length)
    } else {
      this.enfoqueMantenedor = this.initialArrayEnfoque;
    }
  }
  getZonasMantenedor(): any {
    this.loadingEnfoque = true;
    return new Promise((resolve, reject) => {
      this.enfoqueService.getAllCategorias()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  rerenderEnfoque(): void {
    this.loadingEnfoque = false;
    this.inputMessageModal = "";
    this.dtElementEnfoque.dtInstance.then((dtInstanceEnfoque: DataTables.Api) => {
      dtInstanceEnfoque.destroy();
      this.dtTriggerEnfoque.next();
    });
  }
  onCreateEnfoque(modal: any, mode: string, enfoque: any) {
    if (mode === 'Editar') {
      const request: JSON = {
        enfoqueId: enfoque.enfoqueId,
        descripcion: enfoque.enfoqueDescription,
        estado: enfoque.status
      } as unknown as JSON;
      this.enfoqueSelected = request;
    } else {
      const request: JSON = {
        enfoqueId: null,
        descripcion: "",
        estado: 1// Estado habilitado para el enfoque que se creará
      } as unknown as JSON;
      this.enfoqueSelected = request;
    }
    const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
    this.creationMode = mode;
    this.modalService.open(modal, modalOptions);
  }
  openDeleteModalEnfoque(modal: any, enfoque: any): void {
    this.enfoque = enfoque;
    this.confirmationModalHasComment = false;
    this.confirmationModalHasOptions = false;
    this.confirmationModalisCommentObligatory = false;
    this.enfoqueIdSelected = enfoque.enfoqueId;
    this.confirmationModalTittle = 'Eliminar Enfoque';
    this.confirmationModalMessage = `¿Seguro que desea eliminar el enfoque "${enfoque.enfoqueDescription}"?`;
    this.confirmationModalAccept = this.onDeleteEnfoque;
    this.openModal(modal);
  }
  openModal(modal: any, options: any = {}): void {
    const modalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, ...options };
    this.modalService.open(modal, modalOptions);
  }
  onDeleteEnfoque(): void {
    // const enfoque = this.enfoque;
    // const request: JSON = {
    //   enfoque:
    //   {
    //     enfoqueId: enfoque.enfoqueId,
    //     enfoqueDescription: enfoque.enfoqueDescription,
    //     estado: 0
    //   }
    // } as unknown as JSON;
    this.enfoqueService.deleteEnfoque(this.enfoque.enfoqueId)
      .then(() => {
        this.refreshEnfoque();
      })
      .catch(error => console.error(error));
  }
  getEstadoLabel(estado: boolean): string {
    if (estado) {
      return 'Habilitado';
    } else {
      return 'Deshabilitado';
    }
  }
}
